import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON008_Request as CancelReferRequest,
  IAPI_CON008_Response as CancelReferResponse,
  IAPI_CON015_Request,
  IAPI_CON015_Response,
} from "../../../type/apiType";

// 退職手当共済契約解除更新
const httpIAPI_CON015 = async (
  param: IAPI_CON015_Request
): Promise<IAPI_CON015_Response> => {
  let res = await http.post(ApiUrl.API_CON015, {
    ...param,
  });
  return res.data;
};

// 退職手当共済契約解除参照
// API仕様書_契約者
const httpIAPI_CON008 = async (
  param: CancelReferRequest
): Promise<CancelReferResponse> => {
  let res = await http.post(ApiUrl.API_CON008, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON015, httpIAPI_CON008 };
